<rcp-com-card
    cardClass="bg-white {{
        isInsightsDetailView ? '' : 'border border-gray-border'
    }}"
    [hasHeader]="false">
    <div
        class="flex flex-col h-full p-4"
        rcpComLoadingOverlay
        [isLoading]="isLoading">
        @if (!isInsightsDetailView) {
            <h6 class="font-semibold uppercase mb-3">
                Claims: Days To Complete
                <span class="text-sm text-gray-500">(Last 90 Days)</span>
            </h6>
        }

        @if (chartOptions) {
            <ag-charts [options]="chartOptions"></ag-charts>
            <div class="text-center text-xs uppercase font-semibold">Days</div>
            @if (!isInsightsDetailView) {
                <div class="mt-4">
                    <rcp-com-button
                        [buttonStyle]="ButtonStyle.Tertiary"
                        label="View Details"
                        (clickEvent)="routeToReport()"></rcp-com-button>
                </div>
            }
        } @else if (!chartOptions && !isLoading) {
            <p class="text-center text-sm">No data to display</p>
        }
    </div>
</rcp-com-card>
